import { useMutation } from "react-query";
import api from "../../client";
import { FileTypeEnum } from "../../types/files";

const uploadInstitutionLogoRequest = async (
  institutionId: string,
  payload: UploadInstitutionLogoPayload,
): Promise<UploadInstitutionLogoResponseData> => {
  const formdata: FormData = new FormData();
  formdata.append("institution_logo", payload.picture);

  const { data } = await api.post<UploadInstitutionLogoResponseData>(
    `/institution/${institutionId}/institution-logo`,
    formdata,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return data;
};

export interface UploadInstitutionLogoPayload {
  picture: File;
}

export interface InstitutionLogoDetail {
  id: string;
  name: string;
  path: string;
  type: FileTypeEnum;
}

export interface UploadInstitutionLogoResponseData {
  data: InstitutionLogoDetail;
}

export const useUploadInstitutionLogo = () => {
  return useMutation({
    mutationFn: ({
      institutionId,
      ...payload
    }: UploadInstitutionLogoPayload & { institutionId: string }) =>
      uploadInstitutionLogoRequest(institutionId, payload),
  });
};
